export default {
  errorClose: {
    id: 'sourcing_page_error_close',
    defaultMessage: 'Close',
  },
  errorMessage: {
    id: 'sourcing_page_error_message',
    defaultMessage: 'Something went wrong',
  },
  errorTitle: {
    id: 'sourcing_page_error_title',
    defaultMessage: 'Hold up !!',
  },
  export: {
    id: 'sourcing_page_export',
    defaultMessage: 'Export in CSV',
  },
  cantExportLabel: {
    id: 'sourcing_page_cant_export_label',
    defaultMessage:
      'You can export a maximum of 8000 order, please use a filter to reduce the number of results',
  },
  order: {
    id: 'sourcing_page_order',
    defaultMessage: 'Order',
  },
  trackingNumber: {
    id: 'sourcing_page_tracking_number',
    defaultMessage: 'Tracking number',
  },
  customer: {
    id: 'sourcing_page_customer',
    defaultMessage: 'Customer',
  },
  product: {
    id: 'sourcing_page_product',
    defaultMessage: 'Product',
  },
  status: {
    id: 'sourcing_page_status',
    defaultMessage: 'Status',
  },
  remainingTime: {
    id: 'sourcing_page_remaining_time',
    defaultMessage: 'Remaining time',
  },
  tableTitleReceived: {
    id: 'sourcing_page_table_title_received',
    defaultMessage: `{count} {count, plural,
      one {order has just arrived at your place}
      other {orders have just arrived at your place}
    }`,
  },
  tableTitlePending: {
    id: 'sourcing_page_table_title_pending',
    defaultMessage: `{count} {count, plural,
      one {ongoing discussion}
      other {ongoing discussions}
    }`,
  },
  tableTitleAll: {
    id: 'sourcing_page_table_title_all',
    defaultMessage: `{count, plural,
      one {# result}
      other {# results}
    }`,
  },
  delayExpired: {
    id: 'sourcing_page_delay_expired',
    defaultMessage: 'Delay expired by {time}',
  },
  viewMore: {
    id: 'sourcing_page_view_more',
    defaultMessage: 'View more',
  },
  country: {
    id: 'sourcing_page_country',
    defaultMessage: 'Country',
  },
  fullName: {
    id: 'global_full_name',
    defaultMessage: '{firstName} {lastName}',
  },
  seeDetails: {
    id: 'buyback_refurbisher_listing_see_details',
    defaultMessage: 'See details',
  },
}
